import { useEffect } from 'react';

import useTranslation from 'shared/hooks/useTranslation';

import { PageLoader, NoData, Error } from 'components';
import {
  Card,
  CardContainer,
  CardsColumn,
  CardsContainer,
  CardTitle,
  CaseContainer,
} from 'shared/components/styled/Cases';
import CaseHeader from 'shared/components/CaseHeader';

import { Chat, EntityName } from 'features/chat';
import { FileLoader, EntityType } from 'features/file-loader';

import { userCommonCasesApi } from '../../api';

import CaseInfo from './CaseInfo';
import TasksInfo from './TasksInfo';

type UserCommonCaseViewFormProps = {
  caseId: string;
};

const UserCommonCaseViewForm = ({ caseId }: UserCommonCaseViewFormProps) => {
  const { t } = useTranslation();

  const [getCommonCase, { data, isLoading, isFetching, isError }] =
    userCommonCasesApi.useLazyGetCommonCaseQuery();

  const commonCase = data ?? null;

  useEffect(() => {
    getCommonCase(caseId);
  }, [caseId]);

  if (isError) return <Error />;
  if (isLoading || isFetching) return <PageLoader />;
  if (!commonCase) return <NoData />;

  return (
    <CaseContainer>
      <CaseHeader
        title="Palvelupyyntö"
        status={commonCase.Status}
        number={commonCase.Title}
      />
      <CardsContainer>
        <CardsColumn>
          <CaseInfo commonCase={commonCase} />
          <CardContainer>
            <CardTitle>{t('Documents')}</CardTitle>
            <Card>
              <FileLoader
                cached
                entityId={commonCase.Id}
                entityType={EntityType.Incident}
              />
            </Card>
          </CardContainer>
        </CardsColumn>
        <CardsColumn>
          <CardContainer>
            <CardTitle>{t('Chat')}</CardTitle>
            <Card sx={{ padding: 0 }}>
              <Chat entityId={commonCase.Id} entityName={EntityName.Incident} />
            </Card>
          </CardContainer>
          {commonCase.Tasks && !!commonCase.Tasks.length && (
            <TasksInfo tasks={commonCase.Tasks} />
          )}
        </CardsColumn>
      </CardsContainer>
    </CaseContainer>
  );
};

export default UserCommonCaseViewForm;
